export default __webpack_public_path__ + "static/media/shopping.4711e877.svg";